module.exports = __webpack_public_path__ + "files/f95a043adfe8e160605b591296cb7420.png";